import { useSelector } from 'react-redux';

/**
 * The active business id. The backend scopes Profit IQ on the `business`
 * request header, so this never reaches the wire — it is part of every query
 * key so a business switch starts a fresh cache entry instead of leaving the
 * previous business's figures on screen.
 */
export const useBusinessId = () =>
  useSelector((state) => state.business?.currentBusiness?._id);

export default useBusinessId;
